import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { RecallBadgeProps } from "./RecallBadge.types"

const icon = faIcon({ name: "arrow-u-turn-up-left", style: "regular" })

export default function RecallBadge(props: RecallBadgeProps) {
    const { recallToId, size = "md" } = props

    // e.g. "Recall to\nJOB-10001".
    const tooltip = `Recall to\n${recallToId}`

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={tooltip}>
            Recall
        </Badge>
    )
}
